/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Skip_TitleInputs */

const vi_einvoice_skip_title = /** @type {(inputs: Einvoice_Skip_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không xuất hóa đơn cho đơn này`)
};

/**

* @param {Einvoice_Skip_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_skip_title = /** @type {((inputs?: Einvoice_Skip_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Skip_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_skip_title(inputs)
});